import styled from '@emotion/styled';
import { CUSTOM_BREAK_POINT, MOBILE_BREAK_POINT } from '../Block.styled';

export const Card = styled.div<{ color: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 22px;

  position: relative;

  padding-top: 25px;
  padding-bottom: 10px;
  width: 350px;

  min-height: 515px;
  height: fit-content;

  background-color: var(--bg-color);
  border: 3px solid #ffffff;
  color: ${(props) => props.color};
  transform-style: preserve-3d;

  ::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 1px;
    left: 10px;
    right: 0;
    bottom: 0;
    background: ${(props) => props.color};
    box-shadow: 0 0 0 3px white;
    transform: translate3d(0, 0.5em, -1em);
    transition: transform 150ms cubic-bezier(0, 0, 0.58, 1),
      box-shadow 150ms cubic-bezier(0, 0, 0.58, 1);
  }

  @media (max-width: ${MOBILE_BREAK_POINT}px) {
    scale: 0.8;
  }
`;
export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  border: 2px solid #ffffff;
  width: 298px;
  height: 280px;
`;

export const Image = styled.img<{ size: number }>`
  width: fit-content;
  height: ${(props) => props.size}px;

  object-fit: contain;
`;

export const SubjectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
`;

export const MintInfo = styled.div`
  font-size: 18px;
  color: white;
`;

export const Title = styled.div`
  font-size: 42px;
  font-weight: 600;
`;

export const Badge = styled.img`
  position: absolute;
  top: -45px;

  width: 90px;
  height: 90px;
  object-fit: contain;
`;

export const Star = styled.img<{
  top: number;
  left: number;
  size: number;
  glowStart: number;
}>`
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;

  width: fit-content;
  height: ${(props) => props.size}px;
  object-fit: contain;

  @keyframes glow {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  animation: 0.5s linear infinite alternate glow;
  animation-delay: ${(props) => props.glowStart}ms;
`;

export const Line = styled.div`
  width: 298px;
  height: 1px;

  opacity: 1;
  border-bottom: solid white 1px;
`;

export const BenefitList = styled.ul`
  display: flex;
  flex-direction: column;

  gap: 16px;
  width: 298px;

  color: white;
  li {
    font-weight: 500;
    font-size: 18px;
    text-align: left;
    ::before {
      content: '· ';
    }
  }
`;

export const HiddenBenefitWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 10px;

  position: absolute;
  bottom: -140px;
  right: -70px;
  width: 360px;
  height: 150px;
  background-color: #4d5ced;
  border: 3px solid white;
  transform-style: preserve-3d;

  transition-duration: 1s;
  transition-timing-function: ease-in;

  ::before {
    position: absolute;
    content: '';
    width: 100%;
    height: 100%;
    top: 1px;
    left: 10px;
    right: 0;
    bottom: 0;
    background: #f8e338;
    box-shadow: 0 0 0 3px white;

    transform: translate3d(0, 0.5em, -1em);
    transition: transform 150ms cubic-bezier(0, 0, 0.58, 1),
      box-shadow 150ms cubic-bezier(0, 0, 0.58, 1);
  }

  @media (max-width: ${CUSTOM_BREAK_POINT}px) {
    position: relative;
    bottom: 0px;
    right: 0px;
    ::before {
      display: none;
    }
  }
`;

export const DashedLine = styled.div`
  position: absolute;
  bottom: -2.5px;
  border-top: 5px dotted var(--bg-color);
  width: 100%;
`;

export const HiddenBenefitList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: fit-content;
  padding-top: 20px;
  padding-bottom: 20px;

  width: 315px;
  color: white;

  li {
    font-weight: 500;
    font-size: 18px;
    text-align: left;
    ::before {
      content: '· ';
    }
  }
`;
